import Footer from '../components/Footer' 
import Navbar from '../components/navigation/Navbar' 
import { useSessionContext } from '../security/context/SessionContext' 
import React from 'react'
import { Navigate, Outlet, useLocation} from 'react-router-dom'
import PageLoading from '../components/PageLoading' 

const HIDE_NAVBAR_PATHS = [
  "/transaction",
  "/confirmation",
  "/sec/log-in",
  "/sec/create-account"
];

const PrivateLayout = () => {
    const { session } = useSessionContext();
    const location = useLocation();

    if (session === null) {
        return <PageLoading/>; 
    }

    const hideNavbar = HIDE_NAVBAR_PATHS.some(path =>
        location.pathname.startsWith(path)
    );

    return session.isAuthenticated ? (
        <React.Fragment>
             {!hideNavbar && <Navbar />}
            <div className="content">
                <Outlet />
            </div>
            <Footer />
        </React.Fragment>
    ) : <Navigate to="/sec/log-in" />;
}

export const ProtectedRoute = (props: any) => {
    const { session } = useSessionContext();
    const { children } = props;
    const location = useLocation();

    const hideNavbar = HIDE_NAVBAR_PATHS.some(path =>
        location.pathname.startsWith(path)
    );

    return session.isAuthenticated ? 
        <React.Fragment>
           {!hideNavbar && <Navbar />}
            <div className="content">
                {children}
            </div>
            <Footer />
        </React.Fragment> : 
        <Navigate to="/" />
}

export default PrivateLayout
